module.exports = __webpack_public_path__ + "static/img/我的医生.2277ac5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/我的医生.png
// module id = 1345
// module chunks = 382